module.exports = __webpack_public_path__ + "img/shines.cfac27d4.png";